// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__Ev2MO","timer__inner":"Timer_timer__inner__Ary-j"};